import { Link } from 'react-router-dom';
import '../stylesheets/SearchModal.css';
import { getPdfPageLink } from '../utils/pdfUtils';

export function SearchModal({ searchedResults, setModalOpened }) {
    return (
        <div className='ModalPage'>
            <i className='fa-solid fa-xmark' onClick={() => setModalOpened(false)} />

            <h2>Որոնման արդյունքը</h2>
            {!searchedResults.length && <h2 style={{ marginTop: '20px' }}>դատարկ է</h2>}

            <div className='box-container'>
                {
                    searchedResults.map((elem, index) => (
                        <a className='box' href={getPdfPageLink(elem.url, elem.page)} target='_blank' rel='noreferrer' key={index}>
                            <p>{index + 1}. {elem.text}</p>
                            <span>էջ {elem.page}, {elem.title} {elem.year}</span>
                        </a>)
                    )
                }
            </div>
        </div>
    )
}
